export enum GoToEntityType {
  Policy = 1,
  Claim = 2,
  Billing = 3,
  Account = 4,
  Agency = 5
}
